import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card mb-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_co_investigators_details",
  "aria-expanded": "true",
  "aria-controls": "kt_co_investigators_details"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Overview")
  ])
], -1)
const _hoisted_3 = {
  key: 0,
  id: "kt_co_investigators_details",
  class: "collapse show"
}
const _hoisted_4 = { class: "card-body border-top p-9" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-140px" }, "Type"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-140px" }, "Email"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-140px" }, "Phone"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px" }, "Full Name"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px" }, "Mailing Address"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-120px" }, "Created Date")
  ])
], -1)
const _hoisted_8 = { class: "d-flex align-items-center" }
const _hoisted_9 = { class: "d-flex justify-content-start flex-column" }
const _hoisted_10 = { class: "card mb-6" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "card-title border-0 cursor-pointer",
    role: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#kt_account_profile_details",
    "aria-expanded": "true",
    "aria-controls": "kt_account_profile_details"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
      /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Research Study")
    ])
  ])
], -1)
const _hoisted_12 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_13 = {
  key: 0,
  class: "card-body border-top p-9"
}
const _hoisted_14 = { class: "row mb-7" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " This research study proposal is", -1)
const _hoisted_16 = { class: "col-lg-6 fv-row" }
const _hoisted_17 = {
  key: 0,
  class: "fw-bold fs-6"
}
const _hoisted_18 = { class: "row mb-7" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " If the proposal is a grant application, indicate the funding agency ", -1)
const _hoisted_20 = { class: "col-lg-6 fv-row" }
const _hoisted_21 = { class: "fw-bold fs-6" }
const _hoisted_22 = { class: "row mb-7" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " How many months do you anticipate this research will last from the time final approval is granted? ", -1)
const _hoisted_24 = { class: "col-lg-6 fv-row" }
const _hoisted_25 = { class: "fw-bold fs-6" }
const _hoisted_26 = { class: "row mb-7" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Data gathering start date ", -1)
const _hoisted_28 = { class: "col-lg-6 fv-row" }
const _hoisted_29 = { class: "fw-bold fs-6" }
const _hoisted_30 = { class: "row mb-7" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Data gathering end date ", -1)
const _hoisted_32 = { class: "col-lg-6 fv-row" }
const _hoisted_33 = { class: "fw-bold fs-6" }
const _hoisted_34 = { class: "row mb-7" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Is this research funded by an internal or external agency? ", -1)
const _hoisted_36 = { class: "col-lg-6 fv-row" }
const _hoisted_37 = { class: "fw-bold fs-6" }
const _hoisted_38 = { class: "row mb-7" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Selected Agency ", -1)
const _hoisted_40 = { class: "col-lg-6 fv-row" }
const _hoisted_41 = { class: "fw-bold fs-6" }
const _hoisted_42 = { class: "row mb-7" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Agency Name ", -1)
const _hoisted_44 = { class: "col-lg-6 fv-row" }
const _hoisted_45 = { class: "fw-bold fs-6" }
const _hoisted_46 = { class: "row mb-7" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Is notification of IRB approval required by the granting agency? ", -1)
const _hoisted_48 = { class: "col-lg-6 fv-row" }
const _hoisted_49 = { class: "fw-bold fs-6" }
const _hoisted_50 = { class: "row mb-7" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Will this research be utilizing Gannon University student academic records? (E.g., grades, test scores, reflection assignments, etc.). ", -1)
const _hoisted_52 = { class: "col-lg-6 fv-row" }
const _hoisted_53 = { class: "fw-bold fs-6" }
const _hoisted_54 = { class: "row mb-7" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Please list all academic records to be used by this research. ", -1)
const _hoisted_56 = { class: "col-lg-6 fv-row" }
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = { class: "row mb-7" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Is this research being reviewed by any other institutional review board? ", -1)
const _hoisted_60 = { class: "col-lg-6 fv-row" }
const _hoisted_61 = { class: "fw-bold fs-6" }
const _hoisted_62 = { class: "row mb-7" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Please enter the name of the institution ", -1)
const _hoisted_64 = { class: "col-lg-6 fv-row" }
const _hoisted_65 = { class: "fw-bold fs-6" }
const _hoisted_66 = { class: "row mb-7" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Do any of the Investigators or personnel listed on this research have a potential conflict of interest associated with this study? ", -1)
const _hoisted_68 = { class: "col-lg-6 fv-row" }
const _hoisted_69 = { class: "fw-bold fs-6" }
const _hoisted_70 = { class: "row mb-7" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Please select the investigator ", -1)
const _hoisted_72 = { class: "col-lg-6 fv-row" }
const _hoisted_73 = { class: "fw-bold fs-6" }
const _hoisted_74 = { class: "row mb-7" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Please select the category of conflict of interest ", -1)
const _hoisted_76 = { class: "col-lg-6 fv-row" }
const _hoisted_77 = { class: "fw-bold fs-6" }
const _hoisted_78 = { class: "row mb-7" }
const _hoisted_79 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Please describe the conflict of interest ", -1)
const _hoisted_80 = { class: "col-lg-6 fv-row" }
const _hoisted_81 = ["innerHTML"]
const _hoisted_82 = { class: "card mb-6" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "card-title border-0 cursor-pointer",
    role: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#kt_research_activity_details",
    "aria-expanded": "true",
    "aria-controls": "kt_research_activity_details"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
      /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Research Activities")
    ])
  ])
], -1)
const _hoisted_84 = {
  id: "kt_research_activity_details",
  class: "collapse show"
}
const _hoisted_85 = {
  key: 0,
  class: "card-body border-top p-9"
}
const _hoisted_86 = { class: "row mb-7" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Purpose ", -1)
const _hoisted_88 = { class: "col-lg-12 fv-row" }
const _hoisted_89 = ["innerHTML"]
const _hoisted_90 = { class: "row mb-7" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Method ", -1)
const _hoisted_92 = { class: "col-lg-12 fv-row" }
const _hoisted_93 = ["innerHTML"]
const _hoisted_94 = { class: "row mb-7" }
const _hoisted_95 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Research Question ", -1)
const _hoisted_96 = { class: "col-lg-12 fv-row" }
const _hoisted_97 = ["innerHTML"]
const _hoisted_98 = { class: "row mb-7" }
const _hoisted_99 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Research Procedure ", -1)
const _hoisted_100 = { class: "col-lg-12 fv-row" }
const _hoisted_101 = ["innerHTML"]
const _hoisted_102 = { class: "card mb-6" }
const _hoisted_103 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "card-title border-0 cursor-pointer",
    role: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#kt_subject_details",
    "aria-expanded": "true",
    "aria-controls": "kt_subject_details"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
      /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Subject Profile")
    ])
  ])
], -1)
const _hoisted_104 = {
  id: "kt_subject_details",
  class: "collapse show"
}
const _hoisted_105 = {
  key: 0,
  class: "card-body border-top p-9"
}
const _hoisted_106 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-7" }, "Subject", -1)
const _hoisted_107 = { class: "row mb-7" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " 1. How many subjects do you plan to enroll? ", -1)
const _hoisted_109 = { class: "col-lg-6 fv-row" }
const _hoisted_110 = { class: "fw-bold fs-6" }
const _hoisted_111 = { class: "row mb-7" }
const _hoisted_112 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " 2. What is the age range of your targeted population (e.g., general adult population is 18+) ", -1)
const _hoisted_113 = { class: "col-lg-6 fv-row" }
const _hoisted_114 = { class: "fw-bold fs-6" }
const _hoisted_115 = { class: "row mb-7" }
const _hoisted_116 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " 3. Does your target population include Gannon University students? ", -1)
const _hoisted_117 = { class: "col-lg-6 fv-row" }
const _hoisted_118 = { class: "fw-bold fs-6" }
const _hoisted_119 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-7" }, "Subject Characteristics", -1)
const _hoisted_120 = { class: "row mb-7" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " 1. Will any vulnerable populations be targeted to participate in your study? ", -1)
const _hoisted_122 = { class: "col-lg-6 fv-row" }
const _hoisted_123 = {
  key: 0,
  class: "fw-bold fs-6"
}
const _hoisted_124 = { class: "row mb-7" }
const _hoisted_125 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " 2. Which of the following best describe your subject (Checkboxes of the following) ", -1)
const _hoisted_126 = { class: "col-lg-6 fv-row" }
const _hoisted_127 = {
  key: 0,
  class: "fw-bold fs-6"
}
const _hoisted_128 = {
  key: 0,
  class: "row mb-7"
}
const _hoisted_129 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted pb-2" }, " 3. What are the Inclusion and Exclusion criteria for subjects in this study? ", -1)
const _hoisted_130 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_131 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_132 = { class: "fv-row" }
const _hoisted_133 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted mb-7" }, " Inclusion Criteria: ", -1)
const _hoisted_134 = ["innerHTML"]
const _hoisted_135 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_136 = { class: "fv-row" }
const _hoisted_137 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted mb-7" }, " Exclusion Criteria: ", -1)
const _hoisted_138 = ["innerHTML"]
const _hoisted_139 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-7" }, "Subject Location", -1)
const _hoisted_140 = { class: "row mb-7" }
const _hoisted_141 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Please specify the exact location(s) of subjects during research activity (e.g., when data is collected or during an intervention). ", -1)
const _hoisted_142 = { class: "col-lg-6 fv-row" }
const _hoisted_143 = { class: "fw-bold fs-6" }
const _hoisted_144 = { class: "row mb-7" }
const _hoisted_145 = { class: "col-lg-6 fv-row" }
const _hoisted_146 = { class: "fw-bold fs-6" }
const _hoisted_147 = /*#__PURE__*/_createElementVNode("h3", { class: "mb-7" }, "Subject Confidentiality", -1)
const _hoisted_148 = { class: "row mb-7" }
const _hoisted_149 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " 1. Will data identifying the subjects be made available to anyone (e.g., FDA, study sponsor) other than the Principal Investigator? ", -1)
const _hoisted_150 = { class: "col-lg-6 fv-row" }
const _hoisted_151 = { class: "fw-bold fs-6" }
const _hoisted_152 = { class: "row mb-7" }
const _hoisted_153 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " 1b. Please explain the data that will be made available and who will have access to the data, also include these in the Informed Consent: ", -1)
const _hoisted_154 = { class: "col-lg-6 fv-row" }
const _hoisted_155 = { class: "fw-bold fs-6" }
const _hoisted_156 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " 2. Where will the data be stored and for how long? (IRB requires data be stored a minimum of 3 years, but data can be stored longer.) ", -1)
const _hoisted_157 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_158 = { class: "col-lg-6 fv-row" }
const _hoisted_159 = ["innerHTML"]
const _hoisted_160 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_161 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Will any identifiable information be collected from the subjects? (Some examples of identifiable information include but not limited to: photographs, audio recordings, names, other information collected that can be used to identify a subject) ", -1)
const _hoisted_162 = { class: "col-lg-6 fv-row" }
const _hoisted_163 = { class: "fw-bold fs-6" }
const _hoisted_164 = { class: "card mb-6" }
const _hoisted_165 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "card-title border-0 cursor-pointer",
    role: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#kt_recruitment_details",
    "aria-expanded": "true",
    "aria-controls": "kt_recruitment_details"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
      /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Recruitment")
    ])
  ])
], -1)
const _hoisted_166 = {
  id: "kt_recruitment_details",
  class: "collapse show"
}
const _hoisted_167 = {
  key: 0,
  class: "card-body border-top p-9"
}
const _hoisted_168 = { class: "row mb-7" }
const _hoisted_169 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Describe the recruitment strategies you will use for each group of subjects. ", -1)
const _hoisted_170 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_171 = { class: "fv-row" }
const _hoisted_172 = ["innerHTML"]
const _hoisted_173 = { class: "row mb-7" }
const _hoisted_174 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Are subjects chosen from records? ", -1)
const _hoisted_175 = { class: "col-lg-6 fv-row" }
const _hoisted_176 = { class: "fw-bold fs-6" }
const _hoisted_177 = { class: "row mb-7" }
const _hoisted_178 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Who gave approval for use of the records? ", -1)
const _hoisted_179 = { class: "col-lg-6 fv-row" }
const _hoisted_180 = ["innerHTML"]
const _hoisted_181 = { class: "row mb-7" }
const _hoisted_182 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Do the records include any identifiable information? (e.g., name, address, etc.) ", -1)
const _hoisted_183 = { class: "col-lg-6 fv-row" }
const _hoisted_184 = { class: "fw-bold fs-6" }
const _hoisted_185 = { class: "row mb-7" }
const _hoisted_186 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Please enter the identiable information ", -1)
const _hoisted_187 = { class: "col-lg-6 fv-row" }
const _hoisted_188 = ["innerHTML"]
const _hoisted_189 = { class: "row mb-7" }
const _hoisted_190 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Are the records publicly available (available to anyone to access)? ", -1)
const _hoisted_191 = { class: "col-lg-6 fv-row" }
const _hoisted_192 = { class: "fw-bold fs-6" }
const _hoisted_193 = { class: "row mb-7" }
const _hoisted_194 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Will any protected health information (PHI) be accessed or extracted from medical records for your study? See definition of PHI below. ", -1)
const _hoisted_195 = { class: "col-lg-6 fv-row" }
const _hoisted_196 = { class: "fw-bold fs-6" }
const _hoisted_197 = { class: "row mb-7" }
const _hoisted_198 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " How will you be accessing subject PHI? ", -1)
const _hoisted_199 = { class: "col-lg-6 fv-row" }
const _hoisted_200 = { class: "fw-bold fs-6" }
const _hoisted_201 = { class: "row mb-7" }
const _hoisted_202 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Others(Please Specify) ", -1)
const _hoisted_203 = { class: "col-lg-6 fv-row" }
const _hoisted_204 = ["innerHTML"]
const _hoisted_205 = { class: "row mb-7" }
const _hoisted_206 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Will subjects receive gifts, payments, compensation, reimbursement, or extra credit for participating? ", -1)
const _hoisted_207 = { class: "col-lg-6 fv-row" }
const _hoisted_208 = { class: "fw-bold fs-6" }
const _hoisted_209 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-7" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 fw-bold text-muted" }, " Please explain ")
], -1)
const _hoisted_210 = { class: "row mb-7" }
const _hoisted_211 = { class: "col-lg-12 fv-row" }
const _hoisted_212 = ["innerHTML"]
const _hoisted_213 = { class: "card mb-6" }
const _hoisted_214 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "card-title border-0 cursor-pointer",
    role: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#kt_risk_details",
    "aria-expanded": "true",
    "aria-controls": "kt_risk_details"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
      /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Risk and Benefits")
    ])
  ])
], -1)
const _hoisted_215 = {
  id: "kt_risk_details",
  class: "collapse show"
}
const _hoisted_216 = {
  key: 0,
  class: "card-body border-top p-9"
}
const _hoisted_217 = { class: "row mb-7" }
const _hoisted_218 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Does the research involve", -1)
const _hoisted_219 = { class: "col-lg-6 fv-row" }
const _hoisted_220 = {
  key: 0,
  class: "fw-bold fs-6"
}
const _hoisted_221 = { class: "row mb-7" }
const _hoisted_222 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Other risks, specify ", -1)
const _hoisted_223 = { class: "col-lg-6 fv-row" }
const _hoisted_224 = ["innerHTML"]
const _hoisted_225 = { class: "row mb-7" }
const _hoisted_226 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Describe the nature and degree of the risk or harm checked above. ", -1)
const _hoisted_227 = { class: "col-lg-6 fv-row" }
const _hoisted_228 = ["innerHTML"]
const _hoisted_229 = { class: "row mb-7" }
const _hoisted_230 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Describe the precautions that will be taken to minimize risk to the subjects: ", -1)
const _hoisted_231 = { class: "col-lg-6 fv-row" }
const _hoisted_232 = ["innerHTML"]
const _hoisted_233 = { class: "row mb-7" }
const _hoisted_234 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Justify the risk in terms of the potential scientific yield and/or in relation to the anticipated benefits to the subjects ", -1)
const _hoisted_235 = { class: "col-lg-6 fv-row" }
const _hoisted_236 = ["innerHTML"]
const _hoisted_237 = { class: "row mb-7" }
const _hoisted_238 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " List any anticipated direct and societal benefits to participation in this research project. ", -1)
const _hoisted_239 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_240 = { class: "fv-row" }
const _hoisted_241 = ["innerHTML"]
const _hoisted_242 = { class: "row mb-7" }
const _hoisted_243 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Will this research include blood drawing, marrow biopsy sampling, biopsy of other tissues, etc. ", -1)
const _hoisted_244 = { class: "col-lg-6 fv-row" }
const _hoisted_245 = { class: "fw-bold fs-6" }
const _hoisted_246 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-7" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted" }, " State the amount (volume measure) and frequency in which the samples are taken. ")
], -1)
const _hoisted_247 = { class: "row mb-7" }
const _hoisted_248 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Volume ", -1)
const _hoisted_249 = { class: "col-lg-6 fv-row" }
const _hoisted_250 = { class: "fw-bold fs-6" }
const _hoisted_251 = { class: "row mb-7" }
const _hoisted_252 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Frequency ", -1)
const _hoisted_253 = { class: "col-lg-6 fv-row" }
const _hoisted_254 = { class: "fw-bold fs-6" }
const _hoisted_255 = { class: "row mb-7" }
const _hoisted_256 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-6 fw-bold text-muted" }, " Describe how the biological samples will be collected, by who, and where the samples will be stored. ", -1)
const _hoisted_257 = { class: "col-lg-6 fv-row" }
const _hoisted_258 = ["innerHTML"]
const _hoisted_259 = { class: "card mb-6" }
const _hoisted_260 = /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "card-title border-0 cursor-pointer",
    role: "button",
    "data-bs-toggle": "collapse",
    "data-bs-target": "#kt_informed_details",
    "aria-expanded": "true",
    "aria-controls": "kt_informed_details"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
      /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Informed Consent")
    ])
  ])
], -1)
const _hoisted_261 = {
  key: 0,
  id: "kt_informed_details",
  class: "collapse show"
}
const _hoisted_262 = { class: "card-body border-top p-9" }
const _hoisted_263 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder mb-6" }, "Informed Consent Description", -1)
const _hoisted_264 = { class: "mb-6" }
const _hoisted_265 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted mb-6" }, "Description", -1)
const _hoisted_266 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted mb-6" }, " Informed consent document(s) are required (with an exception for some Exempt applications) and must be attached to application upon submission. Informed consent should be at a reading level your target population can comprehend (e.g., 8-9th grade reading level if target population is the general population). Readability level can be determined by using the Flesch-Kincaid Grade Level test in Microsoft Word: ", -1)
const _hoisted_267 = ["href"]
const _hoisted_268 = { class: "row mb-7" }
const _hoisted_269 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted mb-6" }, " 1. How will informed consent be obtained (written or electronic consent is the standard, in some cases other forms of consent can be used) ", -1)
const _hoisted_270 = { class: "fv-row" }
const _hoisted_271 = {
  key: 0,
  class: "fw-bold fs-6"
}
const _hoisted_272 = { class: "fw-bold text-muted mb-6" }
const _hoisted_273 = /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0 mb-7" }, "Informed Consent")
], -1)
const _hoisted_274 = { class: "row mb-7" }
const _hoisted_275 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 fw-bold text-muted mb-7" }, " 1. What forms of consent will be obtained ? ", -1)
const _hoisted_276 = {
  key: 0,
  class: "fw-bold fs-6"
}
const _hoisted_277 = {
  key: 1,
  class: "fw-bold fs-6"
}
const _hoisted_278 = {
  key: 2,
  class: "fw-bold fs-6"
}
const _hoisted_279 = { class: "row mb-7" }
const _hoisted_280 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-12 fw-bold text-muted mb-7" }, " 2. In relation to the actual data gathering, when will consent be discussed and documentation obtained? Be specific. ", -1)
const _hoisted_281 = ["innerHTML"]
const _hoisted_282 = { class: "row mb-7" }
const _hoisted_283 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted" }, " 3. Will the investigator(s) be responsible for administering informed consent documents to all participants? ", -1)
const _hoisted_284 = { class: "fv-row" }
const _hoisted_285 = { class: "fw-bold fs-6" }
const _hoisted_286 = {
  key: 0,
  class: "row mb-7"
}
const _hoisted_287 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted" }, " If no, please name the specific individuals who will obtain informed consent and include their job title and a brief description of your plans to train these individuals to obtain informed consent and answer subjects’ questions. (Specific to research assistants or other individuals): ", -1)
const _hoisted_288 = { class: "fv-row" }
const _hoisted_289 = { class: "fs-6" }
const _hoisted_290 = /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Informed Consent Components")
], -1)
const _hoisted_291 = { class: "row mb-7" }
const _hoisted_292 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted mb-7" }, " 1. A statement that the study involves research, an explanation of the purposes of the research and the expected duration of the subject’s participation, a description of the procedures to be followed, and identification of any procedures that are experimental ", -1)
const _hoisted_293 = { class: "fv-row" }
const _hoisted_294 = { class: "fw-bold fs-6" }
const _hoisted_295 = { class: "row mb-7" }
const _hoisted_296 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted" }, " 2. A description of any reasonably foreseeable risks or discomforts to the subject ", -1)
const _hoisted_297 = { class: "fv-row" }
const _hoisted_298 = { class: "fw-bold fs-6" }
const _hoisted_299 = { class: "row mb-7" }
const _hoisted_300 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted" }, " 3. A description of any benefits to the subject or to others that may reasonably be expected from the research. ", -1)
const _hoisted_301 = { class: "fv-row" }
const _hoisted_302 = { class: "fw-bold fs-6" }
const _hoisted_303 = { class: "row mb-7" }
const _hoisted_304 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted" }, " 4. A disclosure of appropriate alternative procedures or courses of treatment, if any, that might be advantageous to the subject (e.g., If investigating effectiveness of an intervention, describe any other alternative evidence-based and beneficial intervention) ", -1)
const _hoisted_305 = { class: "fv-row" }
const _hoisted_306 = { class: "fw-bold fs-6" }
const _hoisted_307 = { class: "row mb-7" }
const _hoisted_308 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted" }, " 5. A statement describing the extent, if any, to which confidentiality of records identifying the subject will be maintained ", -1)
const _hoisted_309 = { class: "fv-row" }
const _hoisted_310 = { class: "fw-bold fs-6" }
const _hoisted_311 = { class: "row mb-7" }
const _hoisted_312 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted" }, " 6. For research involving more than minimal risk, an explanation as to whether any compensation and an explanation as to whether any medical treatments are available if injury occurs and, if so, what they consist of, or where further information may be obtained (Not applicable if your research does not involve more than minimal risk to the participantsubject). ", -1)
const _hoisted_313 = { class: "fv-row" }
const _hoisted_314 = { class: "fw-bold fs-6" }
const _hoisted_315 = { class: "row mb-7" }
const _hoisted_316 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted" }, " 7. An explanation of whom to contact for answers to pertinent questions about the research and research subjects’ rights, and whom to contact in the event of a research-related injury to the subject. Add this statement to the informed consent: If you have questions about your rights as a participant subject in research, contact IRB Chairperson Stephanie Kubiak at 814-871-5670 or kubiak013@gannon.edu. ", -1)
const _hoisted_317 = { class: "fv-row" }
const _hoisted_318 = { class: "fw-bold fs-6" }
const _hoisted_319 = { class: "row mb-7" }
const _hoisted_320 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted" }, " 8. A statement that participation is voluntary, refusal to participate will involve no penalty or loss of benefits to which the subject is otherwise entitled, and the subject may discontinue participation at any time without penalty or loss of benefits to which the subject is otherwise entitled. Add this statement to the informed consent: “Participation is voluntary. You can stop participating at any time without penalty. If you do not wish to discontinue participating in this study, please do the following: [explain process to discontinue study (e.g., exit out of the survey or notify the principal investigator)]” ", -1)
const _hoisted_321 = { class: "fv-row" }
const _hoisted_322 = { class: "fw-bold fs-6" }
const _hoisted_323 = { class: "row mb-7" }
const _hoisted_324 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted" }, " 9. Add a statement about any research that involves the collection of identifiable private information or identifiable biospecimens: ", -1)
const _hoisted_325 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted" }, " (i) A statement that identifiers might be removed from the identifiable private information or identifiable biospecimens and that, after such removal, the information or biospecimens could be used for future research studies or distributed to another investigator for future research studies without additional informed consent from the subject or the legally authorized representative, if this might be a possibility; or ", -1)
const _hoisted_326 = /*#__PURE__*/_createElementVNode("label", { class: "fw-bold text-muted" }, " (ii) A statement that the subject’s information or biospecimens collected as part of the research, will not be used or distributed for future research studies. If you do not plan to use the data collected in future research, include the following statement: “The information collected from you will be used for this study only and will not be used in future research”. If you do plan to use the data collected in future research, then include a statement indicating this in the informed consent. ", -1)
const _hoisted_327 = { class: "fv-row" }
const _hoisted_328 = { class: "fw-bold fs-6" }
const _hoisted_329 = {
  key: 0,
  class: "card mb-6"
}
const _hoisted_330 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_faculty_details",
  "aria-expanded": "true",
  "aria-controls": "kt_faculty_details"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Faculty Authorization")
  ])
], -1)
const _hoisted_331 = {
  id: "kt_faculty_details",
  class: "collapse show"
}
const _hoisted_332 = {
  key: 0,
  class: "card-body border-top p-9"
}
const _hoisted_333 = {
  key: 0,
  class: "success d-flex bg-light-success rounded border-success border border-dashed p-6 mb-10"
}
const _hoisted_334 = { class: "svg-icon svg-icon-2tx svg-icon-success me-4" }
const _hoisted_335 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_336 = { class: "fw-bold" }
const _hoisted_337 = { class: "fs-6 text-gray-600" }
const _hoisted_338 = {
  key: 1,
  class: "danger d-flex bg-light-danger rounded border-danger border border-dashed p-6 mb-10"
}
const _hoisted_339 = { class: "svg-icon svg-icon-2tx svg-icon-danger me-4" }
const _hoisted_340 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_341 = { class: "fw-bold" }
const _hoisted_342 = { class: "fs-6 text-gray-600" }
const _hoisted_343 = { class: "row mb-7" }
const _hoisted_344 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Sponsor Email", -1)
const _hoisted_345 = { class: "col-lg-10 fv-row" }
const _hoisted_346 = { class: "fw-bold fs-6" }
const _hoisted_347 = { class: "row mb-7" }
const _hoisted_348 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Sponsor Full Name", -1)
const _hoisted_349 = { class: "col-lg-10 fv-row" }
const _hoisted_350 = { class: "fw-bold fs-6" }
const _hoisted_351 = { class: "row mb-7" }
const _hoisted_352 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Sponsor Signature", -1)
const _hoisted_353 = { class: "col-lg-10 fv-row" }
const _hoisted_354 = { class: "fw-bold fs-6" }
const _hoisted_355 = { class: "row mb-7" }
const _hoisted_356 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-2 fw-bold text-muted" }, "Research Description", -1)
const _hoisted_357 = { class: "col-lg-10 fv-row" }
const _hoisted_358 = { class: "fs-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Documents = _resolveComponent("Documents")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_DocumentsRO = _resolveComponent("DocumentsRO")!
  const _component_FacultySubmmitButton = _resolveComponent("FacultySubmmitButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_ctx.currentCoInvestigators.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("table", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentCoInvestigators, (item) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: item.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(item.type), 1),
                        _createElementVNode("td", null, _toDisplayString(item.email), 1),
                        _createElementVNode("td", null, _toDisplayString(item.phone), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, _toDisplayString(item.firstname) + " " + _toDisplayString(item.lastname), 1)
                          ])
                        ]),
                        _createElementVNode("td", null, _toDisplayString(item.address), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.moment(item.createdDate)), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        (_ctx.currentResearch.data != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentResearch.data.researchProposals, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.value
                    }, [
                      (item.isChecked)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(item.text), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.currentResearch.data.fundingAgency), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.currentResearch.data.duration), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                _hoisted_27,
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.moment(_ctx.currentResearch.data.startDate)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.moment(_ctx.currentResearch.data.endDate)), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.currentResearch.data.agencyType), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _hoisted_39,
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.currentResearch.data.agency), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _hoisted_43,
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.currentResearch.data.agencyOther), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.currentResearch.data.isRequiredGrant ? "Yes" : "No"), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _hoisted_51,
                _createElementVNode("div", _hoisted_52, [
                  _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.currentResearch.data.isUtilizeAcademicRecord ? "Yes" : "No"), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("span", {
                    class: "fw-bold fs-6",
                    innerHTML: _ctx.currentResearch.data.allAcademicRecords
                  }, null, 8, _hoisted_57)
                ])
              ]),
              _createElementVNode("div", _hoisted_58, [
                _hoisted_59,
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.currentResearch.data.isReviewed ? "Yes" : "No"), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_62, [
                _hoisted_63,
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.currentResearch.data.reviewerName), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_66, [
                _hoisted_67,
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("span", _hoisted_69, _toDisplayString(_ctx.currentResearch.data.hasConflict ? "Yes" : "No"), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_70, [
                _hoisted_71,
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.currentResearch.data.investigatorId), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_74, [
                _hoisted_75,
                _createElementVNode("div", _hoisted_76, [
                  _createElementVNode("span", _hoisted_77, _toDisplayString(_ctx.currentResearch.data.description), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_78, [
                _hoisted_79,
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("span", {
                    class: "fw-bold fs-6",
                    innerHTML: _ctx.currentResearch.data.coiDescription
                  }, null, 8, _hoisted_81)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_82, [
      _hoisted_83,
      _createElementVNode("div", _hoisted_84, [
        (_ctx.currentResearch.data != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
              _createElementVNode("div", _hoisted_86, [
                _hoisted_87,
                _createElementVNode("div", _hoisted_88, [
                  _createElementVNode("span", {
                    in: "",
                    class: "fs-6",
                    innerHTML: _ctx.currentResearch.data.purpose
                  }, null, 8, _hoisted_89)
                ])
              ]),
              _createElementVNode("div", _hoisted_90, [
                _hoisted_91,
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("span", {
                    class: "fs-6",
                    innerHTML: _ctx.currentResearch.data.method
                  }, null, 8, _hoisted_93)
                ])
              ]),
              _createElementVNode("div", _hoisted_94, [
                _hoisted_95,
                _createElementVNode("div", _hoisted_96, [
                  _createElementVNode("span", {
                    class: "fs-6",
                    innerHTML: _ctx.currentResearch.data.question 
                  }, null, 8, _hoisted_97)
                ])
              ]),
              _createElementVNode("div", _hoisted_98, [
                _hoisted_99,
                _createElementVNode("div", _hoisted_100, [
                  _createElementVNode("span", {
                    class: "fs-6",
                    innerHTML: _ctx.currentResearch.data.procedure
                  }, null, 8, _hoisted_101)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_Documents)
    ]),
    _createElementVNode("div", _hoisted_102, [
      _hoisted_103,
      _createElementVNode("div", _hoisted_104, [
        (_ctx.currentSubject.data != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
              _hoisted_106,
              _createElementVNode("div", _hoisted_107, [
                _hoisted_108,
                _createElementVNode("div", _hoisted_109, [
                  _createElementVNode("span", _hoisted_110, _toDisplayString(_ctx.currentSubject.data.numSubRecruited), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_111, [
                _hoisted_112,
                _createElementVNode("div", _hoisted_113, [
                  _createElementVNode("span", _hoisted_114, _toDisplayString(_ctx.currentSubject.data.researchSubject), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_115, [
                _hoisted_116,
                _createElementVNode("div", _hoisted_117, [
                  _createElementVNode("span", _hoisted_118, _toDisplayString(_ctx.currentSubject.data.isIncludeGannonStudents == true ? "Yes" : "No"), 1)
                ])
              ]),
              _hoisted_119,
              _createElementVNode("div", _hoisted_120, [
                _hoisted_121,
                _createElementVNode("div", _hoisted_122, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentSubject.data.population, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      (index in  [1,2,3,4,5,11,12,13] && item.isChecked)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_123, _toDisplayString(item.text), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_124, [
                _hoisted_125,
                _createElementVNode("div", _hoisted_126, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentSubject.data.population, (item, index2) => {
                    return (_openBlock(), _createElementBlock("div", { key: index2 }, [
                      (index2 in  [6,7,8,9,10] && item.isChecked)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_127, _toDisplayString(item.text), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]),
              (_ctx.currentSubject.data != null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_128, [
                    _hoisted_129,
                    _hoisted_130,
                    _hoisted_131,
                    _createElementVNode("div", _hoisted_132, [
                      _hoisted_133,
                      _createElementVNode("span", {
                        class: "col-lg-6 fv-row",
                        innerHTML: _ctx.currentSubject.data.inclusionCriterial
                      }, null, 8, _hoisted_134)
                    ]),
                    _hoisted_135,
                    _createElementVNode("div", _hoisted_136, [
                      _hoisted_137,
                      _createElementVNode("span", {
                        class: "col-lg-6 fv-row",
                        innerHTML: _ctx.currentSubject.data.exclusionCriterial
                      }, null, 8, _hoisted_138)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_139,
              _createElementVNode("div", _hoisted_140, [
                _hoisted_141,
                _createElementVNode("div", _hoisted_142, [
                  _createElementVNode("span", _hoisted_143, _toDisplayString(_ctx.currentSubject.data.subjectLocation), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_144, [
                _createElementVNode("div", _hoisted_145, [
                  _createElementVNode("span", _hoisted_146, _toDisplayString(_ctx.currentSubject.data.subRecruitedOther), 1)
                ])
              ]),
              _hoisted_147,
              _createElementVNode("div", _hoisted_148, [
                _hoisted_149,
                _createElementVNode("div", _hoisted_150, [
                  _createElementVNode("span", _hoisted_151, _toDisplayString(_ctx.currentSubject.data.isAvailableEveryOne == true ? "Yes" : "No"), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_152, [
                _hoisted_153,
                _createElementVNode("div", _hoisted_154, [
                  _createElementVNode("span", _hoisted_155, _toDisplayString(_ctx.currentSubject.data.confidentialityExplanation), 1)
                ]),
                _hoisted_156,
                _hoisted_157,
                _createElementVNode("div", _hoisted_158, [
                  _createElementVNode("span", {
                    class: "fs-6",
                    innerHTML: _ctx.currentSubject.data.subjectConfidentiality
                  }, null, 8, _hoisted_159)
                ]),
                _hoisted_160,
                _hoisted_161,
                _createElementVNode("div", _hoisted_162, [
                  _createElementVNode("span", _hoisted_163, _toDisplayString(_ctx.currentSubject.data.isInformationIdentifiable == true
                ? "Yes"
                : "No"), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_164, [
      _hoisted_165,
      _createElementVNode("div", _hoisted_166, [
        (_ctx.currentRecruitment.data != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_167, [
              _createElementVNode("div", _hoisted_168, [
                _hoisted_169,
                _hoisted_170,
                _createElementVNode("div", _hoisted_171, [
                  _createElementVNode("span", {
                    class: "fs-6",
                    innerHTML: _ctx.currentRecruitment.data.strategy
                  }, null, 8, _hoisted_172)
                ])
              ]),
              _createElementVNode("div", _hoisted_173, [
                _hoisted_174,
                _createElementVNode("div", _hoisted_175, [
                  _createElementVNode("span", _hoisted_176, _toDisplayString(_ctx.currentRecruitment.data.areChosenFromRecord ? "Yes" : "No"), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_177, [
                _hoisted_178,
                _createElementVNode("div", _hoisted_179, [
                  _createElementVNode("span", {
                    class: "fw-bold fs-6",
                    innerHTML: _ctx.currentRecruitment.data.approvedPerson
                  }, null, 8, _hoisted_180)
                ])
              ]),
              _createElementVNode("div", _hoisted_181, [
                _hoisted_182,
                _createElementVNode("div", _hoisted_183, [
                  _createElementVNode("span", _hoisted_184, _toDisplayString(_ctx.currentRecruitment.data.hasIdentifiableInformation ? "Yes" : "No"), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_185, [
                _hoisted_186,
                _createElementVNode("div", _hoisted_187, [
                  _createElementVNode("span", {
                    class: "fw-bold fs-6",
                    innerHTML: _ctx.currentRecruitment.data.identifiableInformation
                  }, null, 8, _hoisted_188)
                ])
              ]),
              _createElementVNode("div", _hoisted_189, [
                _hoisted_190,
                _createElementVNode("div", _hoisted_191, [
                  _createElementVNode("span", _hoisted_192, _toDisplayString(_ctx.currentRecruitment.data.hasAccess), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_193, [
                _hoisted_194,
                _createElementVNode("div", _hoisted_195, [
                  _createElementVNode("span", _hoisted_196, _toDisplayString(_ctx.currentRecruitment.data.willAccessFromRecord ? "Yes" : "No"), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_197, [
                _hoisted_198,
                _createElementVNode("div", _hoisted_199, [
                  _createElementVNode("span", _hoisted_200, _toDisplayString(_ctx.currentRecruitment.data.accessType), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_201, [
                _hoisted_202,
                _createElementVNode("div", _hoisted_203, [
                  _createElementVNode("span", {
                    class: "fw-bold fs-6",
                    innerHTML: _ctx.currentRecruitment.data.accessTypeOther
                  }, null, 8, _hoisted_204)
                ])
              ]),
              _createElementVNode("div", _hoisted_205, [
                _hoisted_206,
                _createElementVNode("div", _hoisted_207, [
                  _createElementVNode("span", _hoisted_208, _toDisplayString(_ctx.currentRecruitment.data.willSubjectsReceiveAnything ? "Yes" : "No"), 1)
                ])
              ]),
              _hoisted_209,
              _createElementVNode("div", _hoisted_210, [
                _createElementVNode("div", _hoisted_211, [
                  _createElementVNode("span", {
                    class: "fw-bold fs-6",
                    innerHTML: _ctx.currentRecruitment.data.receiveDetail
                  }, null, 8, _hoisted_212)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_213, [
      _hoisted_214,
      _createElementVNode("div", _hoisted_215, [
        (_ctx.currentRisk.data != null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_216, [
              _createElementVNode("div", _hoisted_217, [
                _hoisted_218,
                _createElementVNode("div", _hoisted_219, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentRisk.data.involvedResearch, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.value
                    }, [
                      (item.isChecked)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_220, "* " + _toDisplayString(item.text), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_221, [
                _hoisted_222,
                _createElementVNode("div", _hoisted_223, [
                  _createElementVNode("span", {
                    class: "fw-bold fs-6",
                    innerHTML: _ctx.currentRisk.data.otherInvolvedResearch
                  }, null, 8, _hoisted_224)
                ])
              ]),
              _createElementVNode("div", _hoisted_225, [
                _hoisted_226,
                _createElementVNode("div", _hoisted_227, [
                  _createElementVNode("span", {
                    class: "fw-bold fs-6",
                    innerHTML: _ctx.currentRisk.data.degreeOfRisks
                  }, null, 8, _hoisted_228)
                ])
              ]),
              _createElementVNode("div", _hoisted_229, [
                _hoisted_230,
                _createElementVNode("div", _hoisted_231, [
                  _createElementVNode("span", {
                    class: "fw-bold fs-6",
                    innerHTML: _ctx.currentRisk.data.precautions
                  }, null, 8, _hoisted_232)
                ])
              ]),
              _createElementVNode("div", _hoisted_233, [
                _hoisted_234,
                _createElementVNode("div", _hoisted_235, [
                  _createElementVNode("span", {
                    class: "fw-bold fs-6",
                    innerHTML: _ctx.currentRisk.data.riskInTerms
                  }, null, 8, _hoisted_236)
                ])
              ]),
              _createElementVNode("div", _hoisted_237, [
                _hoisted_238,
                _hoisted_239,
                _createElementVNode("div", _hoisted_240, [
                  _createElementVNode("span", {
                    class: "fs-6",
                    innerHTML: _ctx.currentRisk.data.possibleBenefit
                  }, null, 8, _hoisted_241)
                ])
              ]),
              _createElementVNode("div", _hoisted_242, [
                _hoisted_243,
                _createElementVNode("div", _hoisted_244, [
                  _createElementVNode("span", _hoisted_245, _toDisplayString(_ctx.currentRisk.data.includeSomething ? "Yes" : "No"), 1)
                ])
              ]),
              _hoisted_246,
              _createElementVNode("div", _hoisted_247, [
                _hoisted_248,
                _createElementVNode("div", _hoisted_249, [
                  _createElementVNode("span", _hoisted_250, _toDisplayString(_ctx.currentRisk.data.volume), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_251, [
                _hoisted_252,
                _createElementVNode("div", _hoisted_253, [
                  _createElementVNode("span", _hoisted_254, _toDisplayString(_ctx.currentRisk.data.frequency), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_255, [
                _hoisted_256,
                _createElementVNode("div", _hoisted_257, [
                  _createElementVNode("span", {
                    class: "fw-bold fs-6",
                    innerHTML: _ctx.currentRisk.data.sampleDescription
                  }, null, 8, _hoisted_258)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_259, [
      _hoisted_260,
      (_ctx.currentInformed.data != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_261, [
            _createElementVNode("div", _hoisted_262, [
              _hoisted_263,
              _createElementVNode("div", _hoisted_264, [
                _hoisted_265,
                _hoisted_266,
                _createElementVNode("a", {
                  target: "_blank",
                  href: 'https://support.microsoft.com/en-au/office/get-your-document-s-readability-and-level-statistics-85b4969e-e80a-4777-8dd3-f7fc3c8b3fd2 '
                }, "Link", 8, _hoisted_267)
              ]),
              _createElementVNode("div", _hoisted_268, [
                _hoisted_269,
                _createElementVNode("div", _hoisted_270, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentInformed.data.consentType, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.value
                    }, [
                      (item.isChecked)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_271, _toDisplayString(_ctx.getTextQuestion1(item.text)), 1))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("label", _hoisted_272, " Other: " + _toDisplayString(_ctx.currentInformed.data.subjectWithdrawOther), 1)
                ])
              ]),
              _hoisted_273,
              _createElementVNode("div", _hoisted_274, [
                _hoisted_275,
                (_ctx.currentInformed.data.minorParticipate)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_276, " Child Assent "))
                  : _createCommentVNode("", true),
                (_ctx.currentInformed.data.principalConcent)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_277, " Parental Consent "))
                  : _createCommentVNode("", true),
                (_ctx.currentInformed.data.minorSubjectOther == '1')
                  ? (_openBlock(), _createElementBlock("label", _hoisted_278, " Consent of participants 18 years of age and older "))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_279, [
                _hoisted_280,
                _createElementVNode("span", {
                  innerHTML: _ctx.currentInformed.data.formDistribution
                }, null, 8, _hoisted_281)
              ]),
              _createElementVNode("div", _hoisted_282, [
                _hoisted_283,
                _createElementVNode("div", _hoisted_284, [
                  _createElementVNode("span", _hoisted_285, _toDisplayString(_ctx.currentInformed.data.subjectWithdraw ? "Yes" : "No"), 1)
                ])
              ]),
              (!_ctx.currentInformed.data.subjectWithdraw)
                ? (_openBlock(), _createElementBlock("div", _hoisted_286, [
                    _hoisted_287,
                    _createElementVNode("div", _hoisted_288, [
                      _createElementVNode("span", _hoisted_289, _toDisplayString(_ctx.currentInformed.data.writtenConsentOther), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              _hoisted_290,
              _createElementVNode("div", _hoisted_291, [
                _hoisted_292,
                _createElementVNode("div", _hoisted_293, [
                  _createElementVNode("span", _hoisted_294, _toDisplayString(_ctx.currentInformed.data.r01 ? "Yes" : "No"), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_295, [
                _hoisted_296,
                _createElementVNode("div", _hoisted_297, [
                  _createElementVNode("span", _hoisted_298, _toDisplayString(_ctx.currentInformed.data.r02 ? "Yes" : "No"), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_299, [
                _hoisted_300,
                _createElementVNode("div", _hoisted_301, [
                  _createElementVNode("span", _hoisted_302, _toDisplayString(_ctx.currentInformed.data.r03 ? "Yes" : "No"), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_303, [
                _hoisted_304,
                _createElementVNode("div", _hoisted_305, [
                  _createElementVNode("span", _hoisted_306, _toDisplayString(_ctx.currentInformed.data.r04 ? "Yes" : "No"), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_307, [
                _hoisted_308,
                _createElementVNode("div", _hoisted_309, [
                  _createElementVNode("span", _hoisted_310, _toDisplayString(_ctx.currentInformed.data.r05 ? "Yes" : "No"), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_311, [
                _hoisted_312,
                _createElementVNode("div", _hoisted_313, [
                  _createElementVNode("span", _hoisted_314, _toDisplayString(_ctx.currentInformed.data.r06 ? "Yes" : "No"), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_315, [
                _hoisted_316,
                _createElementVNode("div", _hoisted_317, [
                  _createElementVNode("span", _hoisted_318, _toDisplayString(_ctx.currentInformed.data.r07 ? "Yes" : "No"), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_319, [
                _hoisted_320,
                _createElementVNode("div", _hoisted_321, [
                  _createElementVNode("span", _hoisted_322, _toDisplayString(_ctx.currentInformed.data.r08 ? "Yes" : "No"), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_323, [
                _hoisted_324,
                _hoisted_325,
                _hoisted_326,
                _createElementVNode("div", _hoisted_327, [
                  _createElementVNode("span", _hoisted_328, _toDisplayString(_ctx.currentInformed.data.r09 ? "Yes" : "No"), 1)
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.IsStudentInvestigator == `Yes`)
      ? (_openBlock(), _createElementBlock("div", _hoisted_329, [
          _hoisted_330,
          _createElementVNode("div", _hoisted_331, [
            (_ctx.currentFaculty.data != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_332, [
                  (_ctx.currentFaculty.data.isApproved)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_333, [
                        _createElementVNode("span", _hoisted_334, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen043.svg" })
                        ]),
                        _createElementVNode("div", _hoisted_335, [
                          _createElementVNode("div", _hoisted_336, [
                            _createElementVNode("div", _hoisted_337, " Approved Date: " + _toDisplayString(_ctx.moment(_ctx.currentFaculty.data.decisionDate)), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (
            !_ctx.currentFaculty.data.isApproved &&
            _ctx.currentFaculty.data.signature != null
          )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_338, [
                        _createElementVNode("span", _hoisted_339, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen044.svg" })
                        ]),
                        _createElementVNode("div", _hoisted_340, [
                          _createElementVNode("div", _hoisted_341, [
                            _createElementVNode("div", _hoisted_342, " Rejected Date: " + _toDisplayString(_ctx.moment(_ctx.currentFaculty.data.decisionDate)), 1)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_343, [
                    _hoisted_344,
                    _createElementVNode("div", _hoisted_345, [
                      _createElementVNode("span", _hoisted_346, _toDisplayString(_ctx.currentFaculty.data.email), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_347, [
                    _hoisted_348,
                    _createElementVNode("div", _hoisted_349, [
                      _createElementVNode("span", _hoisted_350, _toDisplayString(_ctx.currentFaculty.data.sponsorDegree) + " " + _toDisplayString(_ctx.currentFaculty.data.fullname), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_351, [
                    _hoisted_352,
                    _createElementVNode("div", _hoisted_353, [
                      _createElementVNode("span", _hoisted_354, _toDisplayString(_ctx.currentFaculty.data.signature), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_355, [
                    _hoisted_356,
                    _createElementVNode("div", _hoisted_357, [
                      _createElementVNode("span", _hoisted_358, _toDisplayString(_ctx.currentFaculty.data.reseachDescription), 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_DocumentsRO, {
      title: "Documents",
      hiddeDocuments: "false",
      optionTarget: "#kt_modal_upload_file4"
    }),
    _createVNode(_component_FacultySubmmitButton, { facultyDetail: _ctx.facultyDetails }, null, 8, ["facultyDetail"])
  ], 64))
}